export default __webpack_public_path__ + "static/media/grief_high.1c8f026a.png";